export enum AppSkins {
  GOTO_APP = 'gotoapp',
  MS_TEAMS = 'msteams',
}

export const getChameleonThemeSkinStyle = async (app: AppSkins) => {
  if (app === AppSkins.MS_TEAMS) {
    return import(`@getgo/chameleon-core/css/msteams.css`)
  }
  return import(`@getgo/chameleon-core/css/gotoapp.css`)
}
